import { type MutationTree } from 'vuex';

import { type IObligationState } from '@/store/obligation-module/types';

export const RECEIVE_RESPONSIBILITIES = 'RECEIVE_RESPONSIBILITIES';

export const mutations: MutationTree<IObligationState> = {
    [RECEIVE_RESPONSIBILITIES](_state, { responsibilities }: { responsibilities: Record<string, string> }) {
        _state.responsibilities = responsibilities;
    }
};
